import React from "react";

import data from "./data";

import MegaNav from "../MegaNav";
export default function Store() {
	return <MegaNav data={data} left={"-35em"} />;
}
